import React from 'react'
import PropTypes from 'prop-types'
import ReactHtmlParser from 'react-html-parser'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'

const Spinner = (props) => {
  const { visible, t, isReactive, reactiveCallback } = props

  const onCancel = () => {
    reactiveCallback()
  }

  return (
    <div className='common-report absolute'>
      <div className={`loader ${visible ? 'show' : ''}`}>
        <div className='box'>
          <div className='icon' />
          <p className='title'>{t('commonReport.loading.title')}</p>
          <p className='text'>
            {ReactHtmlParser(t('commonReport.loading.text'))}
          </p>
          {isReactive && (
            <button className='cancel' onClick={() => onCancel()}>
              {t('commonReport.loading.cancel')}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

Spinner.propTypes = {
  visible: PropTypes.bool,
  t: PropTypes.func,
  isReactive: PropTypes.bool,
  reactiveCallback: PropTypes.func,
  requests: PropTypes.array
}

const SpinnerTranslated = translate(null, {
  wait: true,
  translateFuncName: 't',
})(Spinner)

const mapStateToProps = ({ spinnerReducer: { requests } }) => ({
  requests
})

export default connect(mapStateToProps)(SpinnerTranslated)

// export default Spinner
